/*    
<summary>
   This File contains all the routes constant. 
   Developer:Mohammad Saquib Khan, Created Date:04-April-2024
</summary>
*/

import config from "../../helpers/config-helper";

const appConfig = config();
const baseURL = appConfig.REACT_APP_PUBLIC_URL;
const RoutesConstants = {
  // Login: baseURL + "/login",
  Logout: baseURL + "/logout",
  HucksterUser: baseURL + "/HucksterUser",
  SystemUser: baseURL + "/SystemUser",
  TenantManagement: baseURL + "/TenantManagement",
  BranchManagement: baseURL + "/BranchManagement",
  MediaManagement: baseURL + "/MediaManagement",
  ParkingLotManagement: baseURL + "/ParkingLotManagement",
  IntegratorManagement: baseURL + "/IntegratorManagement",
  CameraManagement: baseURL + "/CameraManagement",
  FoldersManagement: baseURL + "/ManageFolders",
  PriceScheduler: baseURL + "/PriceScheduler",
  UserLogs: baseURL + "/UserLogs",
  SystemLogs: baseURL + "/SystemLogs",
  SoracomAuth: baseURL + "/SoracomAuths",
  RouteGuidance: baseURL + "/RouteGuidance",
  Downloads: baseURL + "/Downloads",

  Dashboard: baseURL + "/Dashboard",
  CustomerManagement: baseURL + "/CustomerManagement",
  ReservationList: baseURL + "/ReservationList",
  ReservationManagement: baseURL + "/ReservationManagement",
  ReservationDetails: baseURL + "/ReservationDetails",
  CancelledReservation:baseURL +"/CancelledReservation",

  ReservationSettings: baseURL + "/ReservationSettings",
  ShiftManagementSettings: baseURL + "/ShiftManagement",
  StoreList: baseURL + "/StoreList",
  TreatmentList: baseURL + "/TreatmentList",
  CategoryList: baseURL + "/CategoryList",
  ProductList: baseURL + "/ProductList",
  StaffInformation: baseURL + "/StaffInformationList",
  ShiftManagement: baseURL + "/ShiftManagement",
  Settings: baseURL + "/Settings",
  OptionMenuList: baseURL + "/OptionMenuList",
  BookingManagement: baseURL + "/BookingManagement",
  // NavigationPage: baseURL + "/NavigationPage",
    PageNotFound: baseURL + "/PageNotFound",
  AgreementList: baseURL + "/AgreementList",
  AgreementRegistration: baseURL + "/AgreementRegistration",
  AgreementDetails: baseURL + "/AgreementDetails",
  SalesMedicalRecords: baseURL + "/SalesMedicalRecords",
  HeadquarterManagement: baseURL + "/HeadquarterManagement",

  //customer-side
  Home: baseURL + "/Home",
  StoreDetails: baseURL + "/StoreDetails",
  CustomerLogin: baseURL + "/customer/login",
  StoreLogin: baseURL + "/store/login",
  HeadQuarterLogin: baseURL + "/headquarter/login",
  StaffLogin: baseURL + "/staff/login",
  GroupLogin: baseURL + "/group/login",
  AdminLogin: baseURL + "/admin/login",
  Profile: baseURL + "/Profile",

  CustomerBookingManagement: baseURL + "/Customer/BookingManagement",

  //store management routes
  StoreTreatmentList: baseURL + "/StoreTreatmentList",
  StoreProductList: baseURL + "/StoreProductList",
  StoreStaffInformation: baseURL + "/StoreStaffInformation",
  StoreOptionMenuList: baseURL + "/StoreOptionMenuList",
  StoreCmsDetails: baseURL + "/StoreCmsDetails",

  ConsumptionTax: baseURL + "/ConsumptionTax",
  UploadIcons: baseURL + "/UploadIcons",  
  UploadTemplates: baseURL + "/UploadTemplates",
  CancelationPolicy: baseURL + "/CancelationPolicy",
  ChaneAgreementPassword: baseURL + "/ChangeAgreementPassword",
  MotivationInStore:baseURL + "/MotivationInStore",
  PaymentInStore: baseURL + "/PaymentInStore",
  ThemeInStore: baseURL + "/ThemeInStore",

  TaxSettings: baseURL + "/TaxSettings",
  TimeSettings: baseURL + "/TimeSettings",
  BusinessTypeSettings: baseURL + "/BusinessTypeSettings",
  StoreMotivationSettings: baseURL + "/StoreMotivationSettings",
  PaymentModeSettings: baseURL + "/PaymentModeSettings",
  LizeraStoreList: baseURL + "/LizeraStoreList",

  InventoryManagement: baseURL + "/Inventory",
  EmailManagement: baseURL + "/EmailManagement",
  TotallingManagementDaily: baseURL + "/Totalling/Daily",
  TotallingManagementWeekly: baseURL + "/Totalling/Weekly",
  TotallingManagementMonthly: baseURL + "/Totalling/Monthly",
  TotallingManagementStaffSales: baseURL + "/Totalling/Staff",
  TotallingManagementPeriodSales: baseURL + "/Totalling/Period",
};
export default RoutesConstants;
